var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      ref: "select",
      class: _vm.customClass,
      attrs: {
        placeholder: _vm.placeholder,
        size: _vm.size,
        name: _vm.name,
        filterable: _vm.filterable,
        clearable: _vm.clearable,
        "automatic-dropdown": _vm.automaticDropdown,
        autocomplete: _vm.autocomplete,
        "popper-class": _vm.popperClass,
        "popper-append-to-body": _vm.popperAppendToBody,
        "default-first-option": _vm.defaultFirstOption,
        remote: _vm.remote,
        "remote-method": _vm.searchOptions,
        loading: _vm.remoteLoading,
        "loading-text": _vm.loadingText,
        "no-match-text": _vm.noMatchText,
        "no-data-text": _vm.noDataText,
        "filter-method": _vm.filterOptions,
        disabled: _vm.isDisabled,
        multiple: _vm.multiple,
        "collapse-tags": _vm.collapseTags,
        "multiple-limit": _vm.multipleLimit,
        "value-key": _vm.valueKey,
        "allow-create": _vm.allowCreate,
        "reserve-keyword": _vm.reserveKeyword
      },
      on: {
        blur: _vm.onBlur,
        focus: _vm.onFocus,
        change: _vm.onChange,
        "visible-change": _vm.onVisibleChange
      },
      nativeOn: {
        click: function($event) {
          _vm.onClick($event)
        },
        "!keydown": function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          _vm.onEnterKey($event)
        }
      },
      model: {
        value: _vm.model,
        callback: function($$v) {
          _vm.model = $$v
        },
        expression: "model"
      }
    },
    _vm._l(_vm.filteredOptions, function(item) {
      return _c(_vm.optionComponent, {
        key: item[_vm.itemKey],
        tag: "component",
        attrs: { item: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3116ce4d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3116ce4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/ui/SasSelect.vue
// module id = null
// module chunks = 